module.exports = __webpack_public_path__ + "img/border_rectangle3.80c7f299.svg";